import PropTypes from 'prop-types';
import React from 'react';
import DataSources from '../../../pages/DataSources/DataSources';
import Table from '../../reusable/Tables/Table';
import css from '../SelectCampaigns.module.css';

const AccountsCampaignsSection = ({
  isDataTab,
  isLoading,
  data,
  type,
  onSearch,
  search,
  filter,
  onChangeFilter,
  onSelectCampaigns,
}) => {
  if (isDataTab) {
    return <DataSources type="budget" handleSearch={onSearch} />;
  }

  return (
    <div className={css.accountsTableWrapper}>
      <Table
        handleSelectCampaigns={onSelectCampaigns}
        isLoading={isLoading}
        data={data}
        type={type}
        handleSearch={onSearch}
        search={search}
        filter={filter}
        setFilter={onChangeFilter}
      />
    </div>
  );
};

AccountsCampaignsSection.propTypes = {
  isDataTab: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape).isRequired,
  type: PropTypes.oneOf(['accounts', 'campaigns', 'data']).isRequired,
  onSearch: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  filter: PropTypes.string.isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  onSelectCampaigns: PropTypes.func.isRequired,
};

export default AccountsCampaignsSection;
